import React from 'react';
import Register from '../components/Auth/Register';
import styled from 'styled-components';

const RegisterPageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const RegisterPage: React.FC = () => {
  return (
    <RegisterPageContainer>
      <Register />
    </RegisterPageContainer>
  );
};

export default RegisterPage;
